import { render, staticRenderFns } from "./PageExercisesListWithCards.vue?vue&type=template&id=1cc54630"
import script from "./PageExercisesListWithCards.vue?vue&type=script&lang=js"
export * from "./PageExercisesListWithCards.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports